import type { TemplateRequestFields } from '@tribeplatform/gql-client/graphql'
import type {
  MutationCreateSpaceFromTemplateArgs,
  TemplateRequest,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useTribeClient } from '../../useTribeClient.js'

export const useCreateSpaceFromTemplate = (options?: {
  fields?: TemplateRequestFields
  useMutationOptions?: UseMutationOptions<
    TemplateRequest,
    Error,
    MutationCreateSpaceFromTemplateArgs
  >
}) => {
  const { useMutationOptions, fields = 'basic' } = options || {}
  const { client } = useTribeClient()

  return useMutation<
    TemplateRequest,
    Error,
    MutationCreateSpaceFromTemplateArgs
  >(
    input => client.spaces.createSpaceFromTemplate(input, fields),
    useMutationOptions,
  )
}
